module.exports = __webpack_public_path__ + "static/media/on_form.e519e795.svg";